import { useMutation } from '@tanstack/react-query';
import { useAppContext } from '../../../webapp/src/Providers/AppProvider/AppContext';
import { captureAnalyticsMutation } from '../../services/react-query/mutation';

import { AnalyticsAppType, AnalyticsModules } from './enums';
import {
  RfqAnalyticsApi,
  CatalogAnalyticsApi,
  ProductMatchAnalyticsApi,
  SalesEnablementAnalyticsApi
} from '../../enums';

const getApi = (module: AnalyticsModules): string => {
  switch (module) {
    case AnalyticsModules.ProductMatch:
      return ProductMatchAnalyticsApi.createAnalytic;
    case AnalyticsModules.AutoRFQList:
    case AnalyticsModules.AutoRFQCreate:
    case AnalyticsModules.AutoRFQEdit:
    case AnalyticsModules.AutoRFQItem:
    case AnalyticsModules.AutoRFQCatalog:
    case AnalyticsModules.AutoRFQProductMatch:
      return RfqAnalyticsApi.createAnalytic;
    case AnalyticsModules.SalesEnablement:
      return SalesEnablementAnalyticsApi.createAnalytic;
    default:
      return CatalogAnalyticsApi.createAnalytic;
  }
};

export const useAnalytics = () => {
  const { user } = useAppContext();
  const { mutateAsync: saveAnalytics } = useMutation(
    captureAnalyticsMutation()
  );

  const captureAnalytics = async (
    data: { [key: string]: any },
    module: AnalyticsModules
  ) => {
    const catalogBodyProperties = {
      module
    };

    const ignoreModule =
      module !== AnalyticsModules.ProductMatch &&
      module !== AnalyticsModules.SalesEnablement;

    const body = {
      companyId: user.CompanyID,
      userId: user.ID,
      appType: AnalyticsAppType.WebApp,
      timestamp: new Date().toISOString(),
      ...(ignoreModule && catalogBodyProperties),
      ...data
    };

    const res = await saveAnalytics({ body, endpoint: getApi(module) });
    return res;
  };

  return { captureAnalytics };
};
